import { apiFetch } from '@/lib/api';

// Programların BAŞVURU formu — panelden kurulur ve yayınlanır.
//
// Bu uç YALNIZCA yayındaki başvuruları döndürür: panelde bir programın başvurusu
// yayından kaldırıldığında listeden düşer → sitedeki "Başvur" butonu kaybolur ve
// yeni başvuru alınmaz (asıl kısıtlama backend'de; form da yayında değildir).
//
// Program SAYFALARININ tanıtım içeriği hâlâ src/data/programs.ts'te (kodda) durur;
// buradan gelen tek bilgi "bu programın açık bir başvuru formu var mı, hangisi".

export type PublicProgramApplication = {
  slug: string; // src/data/programs.ts'teki slug ile aynı
  title: { tr: string; en?: string };
  formId: string; // /form/<formId> adresinde açılır
  formTitle?: string;
};

export function getPublicPrograms() {
  return apiFetch<{ programs: PublicProgramApplication[] }>(
    '/api/public/programs',
  );
}

// Formun site içi adresi (DynamicForm sayfası).
export const programFormPath = (formId: string) => `/form/${formId}`;
